.date {
  color: var(--vkui--color_text_subhead);
  text-align: center;
}
